import apiService from '../services/apiService';
import Contact from '../models/Contact';

export const contactController = {
  getAll: async (filters = {}) => {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const endpoint = queryParams ? 'contacts?${queryParams}' : 'contacts';
      const response = await apiService.get(endpoint);
      const items = response.data?.map(item => Contact.fromJSON(item)) || [];
      return { success: true, data: items, total: response.total || items.length };
    } catch (error) {
      return { success: false, data: [], message: error.message || 'Failed to fetch contacts' };
    }
  },

  getById: async (id) => {
    try {
      const response = await apiService.get(`contacts/${id}`);
      return { success: true, data: Contact.fromJSON(response.data) };
    } catch (error) {
      return { success: false, data: null, message: error.message };
    }
  },

  create: async (data) => {
    try {
      const item = new Contact(data);
      const validation = item.validate();
      if (!validation.isValid) return { success: false, errors: validation.errors };
      const response = await apiService.post('contacts', item.toJSON());
      return { success: true, data: Contact.fromJSON(response.data), message: 'Contact created successfully' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },
  createPublicInquiry: async (data) => {
    try {
      // Direct fetch call without authentication
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000/v1'}/contacts/public/inquiry`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (!response.ok) {
        return { 
          success: false, 
          message: result.message || 'Failed to submit inquiry',
          errors: result.errors 
        };
      }

      return { 
        success: true, 
        data: result.data, 
        message: result.message || 'Inquiry submitted successfully' 
      };
    } catch (error) {
      return { 
        success: false, 
        message: error.message || 'Network error. Please try again.' 
      };
    }
  },
  update: async (id, data) => {
    try {
      const item = new Contact({ ...data, id });
      const validation = item.validate();
      if (!validation.isValid) return { success: false, errors: validation.errors };
      const response = await apiService.put(`contacts/${id}`, item.toJSON());
      return { success: true, data: Contact.fromJSON(response.data), message: 'Contact updated successfully' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  delete: async (id) => {
    try {
      await apiService.delete(`contacts/${id}`);
      return { success: true, message: 'Contact deleted successfully' };
    } catch (error) {
      return { success: false, message: error.message };
    }
  },

  export: async (filters = {}, format = 'csv') => {
    try {
      const queryParams = new URLSearchParams({ ...filters, format }).toString();
      const response = await apiService.get(`contacts/export?${queryParams}`);
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, message: error.message };
    }
  }
};

export default contactController;